var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "sales-container" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c(
              "router-link",
              {
                staticClass: "sub-heading cursor-pointer",
                attrs: { to: "/layout/launchpad" },
              },
              [
                _c("i", { staticClass: "fa fa-angle-left" }),
                _vm._v("Add " + _vm._s(_vm.roleDetails.role_name || "") + " "),
              ]
            ),
            _c("div", { staticClass: "row m-0 mb-15" }, [
              _c("div", { staticClass: "note" }, [
                _vm._v(
                  " Note: " +
                    _vm._s(_vm.roleDetails.role_name || "") +
                    " user will have access to all the REP accounts by default. "
                ),
              ]),
            ]),
            _c("div", { staticClass: "row m-0 mt-25" }, [
              _vm._m(0),
              _c("div", { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.roleDetails.role_name,
                      expression: "roleDetails.role_name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.roleDetails.role_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.roleDetails,
                        "role_name",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._m(1),
              _c("div", { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sales.first_name,
                      expression: "sales.first_name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Name", maxlength: "35" },
                  domProps: { value: _vm.sales.first_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.sales, "first_name", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._m(2),
              _c("div", { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sales.last_name,
                      expression: "sales.last_name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Name", maxlength: "35" },
                  domProps: { value: _vm.sales.last_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.sales, "last_name", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._m(3),
              _c("div", { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" }, [
                _c("div", { staticClass: "col-xs-12 p-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sales.email,
                        expression: "sales.email",
                      },
                    ],
                    staticClass: "form-control",
                    class:
                      (_vm.sales.email && _vm.sales.email.length < 2) ||
                      (_vm.sales.email &&
                        _vm.sales.email.length > 1 &&
                        !_vm.validEmail) ||
                      _vm.emailExists
                        ? "invalid-border"
                        : "",
                    attrs: {
                      type: "text",
                      placeholder: "Email",
                      maxlength: "65",
                    },
                    domProps: { value: _vm.sales.email },
                    on: {
                      change: _vm.validateEmail,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.sales, "email", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-xs-12 p-0" }, [
                  _vm.sales.email && _vm.sales.email.length < 2
                    ? _c("div", { staticClass: "custom-error-class" }, [
                        _vm._v(
                          " Please enter at least 2 characters for email. "
                        ),
                      ])
                    : _vm._e(),
                  _vm.sales.email &&
                  _vm.sales.email.length > 1 &&
                  !_vm.validEmail
                    ? _c("div", { staticClass: "custom-error-class" }, [
                        _vm._v(" Please enter a valid email address. "),
                      ])
                    : _vm._e(),
                  _vm.emailExists
                    ? _c("div", { staticClass: "custom-error-class" }, [
                        _vm._v(" Email already registered with the account. "),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-offset-1 col-xs-10 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.disableButtonForAddTeam || _vm.loaderStatus,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addSalesTeam()
                        },
                      },
                    },
                    [_vm._v(" Save Changes ")]
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 form-group" }, [
      _c("label", [_vm._v("Role")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 form-group" }, [
      _c("label", [_vm._v("First Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 form-group" }, [
      _c("label", [_vm._v("Last Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 form-group" }, [
      _c("label", [_vm._v("Email")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }